import { AppleSignInButton } from "./AppleSignInButton";

interface Props {
  returnPath: string;
}

export function AppleJoinButton({ returnPath }: Props) {
  return <AppleSignInButton returnPath={returnPath} />;
}
